import { HttpClient } from "@angular/common/http";
import { environment } from "../../../../environments/environment";
import { Observable } from "rxjs";
import { Injectable, inject } from "@angular/core";
import { AtendimentoDetalhesModel } from "../model/atendimento/atendimento-detalhes.model";

@Injectable({
  providedIn: 'root'
})
export class AtendimentoService {

  private readonly http = inject(HttpClient);

  urlBase = `${environment.urlBase}/atendimento`;

  encerrarAtendimentoContatoId(contatoId: number): Observable<any> {
    return this.http.put<boolean>(`${this.urlBase}/encerrar`, contatoId);
  }

  buscarDetalhes(atendimentoId: number): Observable<AtendimentoDetalhesModel> {
    return this.http.get<AtendimentoDetalhesModel>(`${this.urlBase}/${atendimentoId}/detalhes`);
  }

  visualizarTransferencia(contatoId: number): Observable<any> {
    return this.http.put<boolean>(`${this.urlBase}/visualizar-transferencia/{contatoId}`, contatoId);
  }

}
